// src/services/aiTipAPI.js
import { API_BASE_URL } from '../../config/api';

// Helper function to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('access_token');
  console.log('🔑 Token from localStorage:', token ? 'Present' : 'Missing');
  
  if (!token) {
    console.error('❌ No JWT token found in localStorage');
  }
  
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

// Helper function to handle API responses
const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(errorData.error || errorData.message || 'Request failed');
  }
  const data = await response.json();
  console.log('✅ API Response:', data);
  return data;
};

// GET - Get AI tips
export const getAITipsAPI = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.category) queryParams.append('category', params.category);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.random !== undefined) queryParams.append('random', params.random);
    
    const queryString = queryParams.toString();
    const url = `${API_BASE_URL}/api/ai-tips${queryString ? `?${queryString}` : ''}`;
    
    const res = await fetch(url, {
      method: 'GET',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Get AI tips error:', error);
    throw error;
  }
};

// GET - Get tip by ID
export const getTipByIdAPI = async (tipId) => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/ai-tips/${tipId}`, {
      method: 'GET',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Get tip by ID error:', error);
    throw error;
  }
};

// POST - Submit tip feedback
export const submitTipFeedbackAPI = async (tipId, feedbackData) => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/ai-tips/${tipId}/feedback`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(feedbackData),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Submit tip feedback error:', error);
    throw error;
  }
};

// POST - Create new tip (Admin)
export const createTipAPI = async (tipData) => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/ai-tips`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(tipData),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Create tip error:', error);
    throw error;
  }
};

// Helper function to handle API errors
export const handleAPIError = (error) => {
  console.error('API Error:', error);
  return {
    message: error.message || 'An unexpected error occurred',
    status: 0,
  };
};
